import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import chroma from 'chroma-js';
import { animationTransition } from '@joykit/variables';
import { space } from '@joykit';
export namespace styles {
  export const container = css({
    minHeight: 92
  });

  export const floater = (fixed: boolean) =>
    css(
      {
        display: 'flex'
      },
      fixed
        ? {
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 80px)',
            maxWidth: '1600px',
            zIndex: 2,
            backgroundColor: 'white',
            boxShadow: '0px 14px 24px -14px rgba(0,0,0,0.2)'
          }
        : undefined
    );

  export const floatingButtonContainer = css({
    minHeight: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':not(:last-child)': {
      margin: '0 0 1.5rem 0'
    },
    '@media(min-width: 678px)': {
      ':not(:last-child)': {
        margin: space.stack.xl
      }
    }
  });

  export const floatingButton = (fixed: boolean) =>
    css(
      {
        padding: '16px 64px',
        backgroundColor: '#333',
        color: 'white',
        letterSpacing: '.3px',
        zIndex: 3,
        width: 220,
        ...getInterUIDynamicMetricCssObject(14),
        transition: animationTransition('background-color'),
        ':hover': {
          backgroundColor: chroma('#333')
            .darken()
            .css()
        }
      },
      fixed
        ? {
            position: 'fixed',
            top: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
            boxShadow: '0px 14px 24px -14px rgba(0,0,0,0.2)'
          }
        : undefined
    );

  export const doneButton = css({
    padding: '16px 64px',
    backgroundColor: '#333',
    color: '#fff',
    letterSpacing: '.3px',
    ...getInterUIDynamicMetricCssObject(14),
    transition: animationTransition('background-color'),
    ':hover': {
      backgroundColor: chroma('#333')
        .darken()
        .css()
    }
  });

  export const doneButtonWrapper = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    bottom: 32
  });

  export const logo = css({
    marginBottom: 32
  });

  export const designPanelInner = css({
    minHeight: '100%'
  });

  export const clear = css({
    marginBottom: 96
  });

  export const popupPosition = css({
    zIndex: 10
  });

  export const header = css({
    fontFamily: 'PT serif',
    fontSize: '32px',
    lineHeight: '45px',
    fontWeight: 'normal',
    margin: space.stack.md
  });
}
